import React from "react";
import { makeStyles } from "@mui/styles";
import Loader from "./Loader";

const useStyles = makeStyles(() => ({
  loader: {
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    position: "fixed",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

const PageLoader = () => {
  const classes = useStyles();
  return (
    <div className={classes.loader}>
      <Loader />
    </div>
  );
};

export default PageLoader;
